import { Abas } from '@core/components/Abas';
import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { useReduxLoading } from '@core/hooks';
import { useApiUtils } from '@core/util/apiUtils';
import { Grid } from '@material-ui/core';
import { cancelarAlert } from 'app/services/alerts';
import empresaApi from 'app/services/api/empresaApi';
import * as Actions from 'app/store/actions';
import { GlobalContext } from 'app/store/globalcontext';
import { eventReactGA } from 'app/utils/analyticsUtil';
import { FormikProvider, useFormik } from 'formik';
import React, { useContext, useEffect, useState } from 'react';
import { FaBuilding } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { EmpresaModais } from '../EmpresaModais';
import EmpresaSchema from './schemas/EmpresaSchemas';
import { TabContato, TabDadosGerais, TabEndereco, TabTributacao } from './tabs';

const EmpresaCadastroModal = ({ fetchData, modal, setModalContextoEmpresa = () => {} }) => {
  const [modalEmpresa, setModalEmpresa] = useContext(GlobalContext).modalEmpresa;
  const [selecionarAba, setSelecionarAba] = useState(0);
  const [loading, setLoading] = useState(false);
  const [, setEdicao] = useState(false);
  const [empresa, setEmpresa] = useContext(GlobalContext).empresa;
  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  useReduxLoading(loading);

  const onInit = () => {
    setEdicao(!!empresa.id);
  };

  useEffect(onInit, []);

  const initialValues = {
    ...empresa,
    tipoPessoa: empresa?.tipoPessoa || 'JURIDICA',
    produtorRural: empresa?.produtorRural ? 'TRUE' : 'FALSE',
    optanteSimples: empresa?.optanteSimples ? 'TRUE' : 'FALSE',
    incentivadorCultural: empresa?.incentivadorCultural ? 'TRUE' : 'FALSE',
    ibsCbs: empresa?.ibsCbs || false,
    contribuinteIbs: empresa?.contribuinteIbs ? 'TRUE' : 'FALSE',
    contribuinteCbs: empresa?.contribuinteCbs ? 'TRUE' : 'FALSE',
    contribuinteIs: empresa?.contribuinteIs ? 'TRUE' : 'FALSE',
    tipoIndicadorOperacao: empresa?.tipoIndicadorOperacao || '',
    codigoOperacaoIbsCbs: {
      id: empresa?.codigoOperacaoIbsCbs?.id || '',
      codigo: empresa?.codigoOperacaoIbsCbs?.codigo || empresa?.codigoOperacaoIbsCbs || '',
      descricao: empresa?.codigoOperacaoIbsCbs?.descricao || '',
    },
    nbs: {
      id: empresa?.nbs?.id || '',
      codigo: empresa?.nbs?.codigo || '',
      descricao: empresa?.nbs?.descricao || '',
    },
    cstSituacaoTributaria: {
      id: empresa?.cstSituacaoTributaria?.id || '',
      codigo: empresa?.cstSituacaoTributaria?.codigo || '',
      descricao: empresa?.cstSituacaoTributaria?.descricao || '',
      idSituacao: empresa?.cstSituacaoTributaria?.idSituacao || '',
    },
    cstClassificacaoTributaria: {
      id: empresa?.cstClassificacaoTributaria?.id || '',
      codigo: empresa?.cstClassificacaoTributaria?.codigo || '',
      descricao: empresa?.cstClassificacaoTributaria?.descricao || '',
      cstPaiId: empresa?.cstClassificacaoTributaria?.cstPaiId || '',
    },
  };

  const close = () => {
    formik.resetForm({});
    setEmpresa({});
    setModalEmpresa(false);
    setModalContextoEmpresa('');
  };

  const handleCloseModal = () => {
    if (formik.dirty) {
      cancelarAlert({
        confirmar: close,
      });
    } else {
      close();
    }
  };

  const showMessage = (message, variant) => {
    dispatch(
      Actions.showMessage({
        message,
        variant,
      })
    );
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    values.cnaeId = values?.cnae?.id;
    delete values.cnae;

    values.planoComercialId = values.planoComercial?.id;
    delete values.planoComercial;

    values.nbsId = values?.nbs?.id || null;
    delete values.nbs;

    values.cstSituacaoTributariaId = values?.cstSituacaoTributaria?.id || null;
    delete values.cstSituacaoTributaria;

    values.cstClassificacaoTributariaId = values?.cstClassificacaoTributaria?.id || null;
    delete values.cstClassificacaoTributaria;

    values.codigoOperacaoIbsCbs = values?.codigoOperacaoIbsCbs?.codigo || null;

    values.tipoIndicadorOperacao = values?.tipoIndicadorOperacao || null;

    if (values.produtorRural) {
      values.produtorRural = values.produtorRural === 'TRUE' ? true : values.produtorRural === 'FALSE' ? false : null;
    }

    if (values.optanteSimples) {
      values.optanteSimples =
        values.optanteSimples === 'TRUE' ? true : values.optanteSimples === 'FALSE' ? false : null;
    }

    if (values.incentivadorCultural) {
      values.incentivadorCultural =
        values.incentivadorCultural === 'TRUE' ? true : values.incentivadorCultural === 'FALSE' ? false : null;
    }

    if (values.pessoa.tipoPessoa === 'JURIDICA') {
      values.pessoa.pessoaFisica = undefined;
    } else if (values.pessoa.tipoPessoa === 'FISICA') {
      values.pessoa.pessoaJuridica = undefined;
    }

    if (values.contribuinteIbs) {
      values.contribuinteIbs =
        values.contribuinteIbs === 'TRUE' ? true : values.contribuinteIbs === 'FALSE' ? false : false;
    }

    if (values.contribuinteCbs) {
      values.contribuinteCbs =
        values.contribuinteCbs === 'TRUE' ? true : values.contribuinteCbs === 'FALSE' ? false : false;
    }

    if (values.contribuinteIs) {
      values.contribuinteIs =
        values.contribuinteIs === 'TRUE' ? true : values.contribuinteIs === 'FALSE' ? false : false;
    }

    if (values?.pessoa?.tipoPessoa === 'JURIDICA' && values?.pessoa?.pessoaJuridica?.cnpj) {
      values.pessoa.pessoaJuridica.cnpj = values.pessoa.pessoaJuridica.cnpj.replace(/[.\-/]/g, '');
    } else if (values?.pessoa?.tipoPessoa === 'FISICA' && values?.pessoa?.pessoaFisica?.cpf) {
      values.pessoa.pessoaFisica.cpf = values.pessoa.pessoaFisica.cpf.replace(/[.\-/]/g, '');
    }

    const _empresa = JSON.parse(JSON.stringify(values));

    try {
      if (empresa.id) {
        eventReactGA('Empresa', 'Atualizar empresa');
        await empresaApi.atualizar(empresa.id, _empresa);
        showMessage('Empresa editada com sucesso', 'success');
      } else {
        eventReactGA('Empresa', 'Cadastrar empresa');
        await empresaApi.cadastrar(_empresa);
        showMessage('Empresa salva com sucesso', 'success');
      }

      setLoading(false);
      close();
      if (fetchData) {
        fetchData();
      }
    } catch (err) {
      setLoading(false);
      apiUtils.handleApiError(err);
    }
  };

  const formik = useFormik({
    validationSchema: EmpresaSchema,
    initialValues,
    onSubmit: handleSubmit,
    validateOnChange: true,
  });

  useEffect(() => {
    formik.resetForm(initialValues);
    // Reset controlado pelo gatilho acima; incluir o formulário/valores reiniciaria o
    // preenchimento enquanto o usuário edita.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresa]);

  const dadosGeraisError = !!(formik.submitCount > 0
    ? formik.errors?.comercializacao || formik.errors?.pessoa?.nome || formik.errors?.nomeRemetente
    : (formik.errors?.comercializacao && formik.touched?.comercializacao) ||
      (formik.errors?.pessoa?.nome && formik.touched?.pessoa?.nome) ||
      (formik.errors?.nomeRemetente && formik.touched?.nomeRemetente));

  const tributacaoErrorFields = [
    'produtorRural',
    'optanteSimples',
    'regimeTributario',
    'regimeTributarioEspecial',
    'ibsCbs',
    'cstSituacaoTributaria',
    'cstClassificacaoTributaria',
    'contribuinteIbs',
    'contribuinteCbs',
    'contribuinteIs',
    'tipoIndicadorOperacao',
    'codigoOperacaoIbsCbs',
  ];

  const tributacaoError = tributacaoErrorFields.some((field) => {
    if (formik.submitCount > 0) {
      return !!formik.errors?.[field];
    }
    return !!formik.errors?.[field] && !!formik.touched?.[field];
  });

  return (
    <SimpleDialog
      fullScreen
      open={modalEmpresa === EmpresaModais.cadastrarEmpresa || modal === EmpresaModais.cadastrarEmpresa}
      onClose={handleCloseModal}
    >
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          fullScreen
          header={{
            title: 'Minha empresa',
            icon: <FaBuilding />,
            toolbar: (
              <>
                <CancelButton title="cancelar" type="button" onClick={handleCloseModal}>
                  Cancelar
                </CancelButton>
                <SaveButton color="buttonSave" type="submit">
                  Salvar
                </SaveButton>
              </>
            ),
          }}
          contentToolbar={
            <Abas
              value={selecionarAba}
              onChange={setSelecionarAba}
              tabs={[
                {
                  label: 'Dados gerais',
                  hasError: () => dadosGeraisError,
                },
                {
                  label: 'Tributação',
                  hasError: () => tributacaoError,
                },
                {
                  label: 'Endereço',
                  hasError: () => {
                    return false;
                  },
                },
                {
                  label: 'Contato',
                  hasError: () => {
                    return false;
                  },
                },
              ]}
            />
          }
          content={
            <div className="h-full max-h-full w-full">
              <Grid container spacing={3}>
                {selecionarAba === 0 && (
                  <TabDadosGerais setLoading={setLoading} handleApiError={apiUtils.handleApiError} />
                )}
                {selecionarAba === 1 && <TabTributacao />}
                {selecionarAba === 2 && <TabEndereco />}
                {selecionarAba === 3 && <TabContato />}
              </Grid>
            </div>
          }
        />
      </FormikProvider>
    </SimpleDialog>
  );
};

export default EmpresaCadastroModal;
